import { render, staticRenderFns } from "./LivestreamAlexaPrivacyPolicy.vue?vue&type=template&id=5df4c662&scoped=true"
import script from "./LivestreamAlexaPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LivestreamAlexaPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4c662",
  null
  
)

export default component.exports